import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import CreateTransactionForm from '../../components/CreateTransactionForm';
import { getUserFromStorage } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';

const AgentCreateTransactionPage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (storedUser?.role === 'agent' || storedUser?.role === 'admin') {
      setUser(storedUser);
    } else {
      navigate('/login'); // ✅ redirect if not admin
    }
  }, [navigate]);

  if (!user) return null;

  const storedUser2 = getUserFromStorage();

  return (
    <DashboardLayout role={storedUser2?.role}>
      <CreateTransactionForm user={user} />
    </DashboardLayout>
  );
};

export default AgentCreateTransactionPage;
